export default __webpack_public_path__ + "static/media/kasol.0a36214a.jpg";